import React, { useId, useRef, useState } from 'react';
import LibraryDialog from '../../Library/LibraryDialog';
import Select from '../../shared/Select';
import { Required } from '../FieldMarks';
import { SETTINGS_ROLES, USER_STATUSES } from '../../../../models/SettingsModel';
import '../../Library/AddDocumentDialog.css'; // library-form-group

const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

/**
 * Add user (Navy Phase 0, story 30). Every field is required; Status starts on
 * Active. Save user stays disabled until the form is complete, with a
 * well-formed email. Focus starts on the name.
 */
function UserDialog({ opener, fallbackFocus, onSave, onClose }) {
  const ids = useId();
  const nameRef = useRef(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');
  const [status, setStatus] = useState(USER_STATUSES[0]);
  const canSave = !!(name.trim() && EMAIL.test(email.trim()) && role && status);

  return (
    <LibraryDialog title="Add user" initialFocus={nameRef} opener={opener} fallbackFocus={fallbackFocus} onClose={onClose}>
      <div className="resui-field library-form-group">
        <label className="resui-field-label" htmlFor={`${ids}-name`}>Name<Required /></label>
        <input ref={nameRef} id={`${ids}-name`} type="text" className="resui-input" placeholder="Full name" value={name} onChange={(e) => setName(e.target.value)} />
      </div>
      <div className="resui-field library-form-group">
        <label className="resui-field-label" htmlFor={`${ids}-email`}>Email<Required /></label>
        <input id={`${ids}-email`} type="email" className="resui-input" placeholder="email@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
      </div>
      <div className="resui-field library-form-group">
        <label className="resui-field-label" htmlFor={`${ids}-role`}>Role<Required /></label>
        <Select
          id={`${ids}-role`}
          className="resui-select-field--block"
          value={role}
          options={[{ value: '', label: 'Select role' }, ...SETTINGS_ROLES]}
          onChange={setRole}
        />
      </div>
      <div className="resui-field library-form-group">
        <label className="resui-field-label" htmlFor={`${ids}-status`}>Status<Required /></label>
        <Select id={`${ids}-status`} className="resui-select-field--block" value={status} options={USER_STATUSES} onChange={setStatus} />
      </div>
      <div className="library-dialog-actions">
        <button type="button" className="resui-btn resui-btn--secondary" onClick={onClose}>Cancel</button>
        <button
          type="button"
          className="resui-btn resui-btn--primary"
          disabled={!canSave}
          onClick={() => canSave && onSave({ name, email, role, status })}
        >
          Save user
        </button>
      </div>
    </LibraryDialog>
  );
}

export default UserDialog;
